import React, { useEffect, useState } from 'react';
import { useQuestionToggleAtom } from '../../atoms/chat/useQuestionToggleAtom';
import { useSelectedTabAtom } from '../../atoms/chat/useSelectedTabAtom';
import { useAtom } from 'jotai';
import { useChatEnvironmentAtom } from '../../atoms/chat/useChatEnvironmentAtom';
import { useFavouriteQuestionsAtom } from '../../atoms/chat/useFavouriteQuestionsAtom';
import { useFormButtonEnabledAtom } from '../../atoms/chat/useFormButtonEnabledAtom';
import { useFormInputEnabledAtom } from '../../atoms/chat/useFormInputEnabledAtom';
import { getFavouriteQuestions, deleteFavouriteQuestion } from '../../api/questionAPIs';
import {selectedQuestionAtom} from "../../atoms/chat/useSelectedQuestionAtom";
import { useTranslation } from 'react-i18next';
import useCookie from '../../hooks/useCookie';
import VersionDisplay from '../VersionDisplay';

const ChatQuestions = () => {
  const [, setCookie, ] = useCookie("ENV");
  const [ulaCookie,] = useCookie("ULA");
  const [t,] = useTranslation('global');

  const [selectedTab] = useSelectedTabAtom();
  const [isQuestionsVisible, setIsQuestionsVisible] = useQuestionToggleAtom();
  const [favQuestions, setFavQuestions] = useFavouriteQuestionsAtom();
  const [formButtonEnabled, setFormButtonEnabled] = useFormButtonEnabledAtom();
  const [, setFormInputEnabled] = useFormInputEnabledAtom();
  const [chatEnvironmentId, setChatEnvironmentId] = useChatEnvironmentAtom();
  const [, setSelectedQuestion] = useAtom(selectedQuestionAtom);

  const [uniqueEnvironmentNames, setUniqueEnvironmentNames] = useState([]);
  const [draggingItem, setDraggingItem] = useState(null);

  const fetchQuestions = () => {
    const lang = JSON.parse(ulaCookie);
    let savedQuestions = getFavouriteQuestions(selectedTab, lang);
    setFavQuestions(savedQuestions);
  }

  const populateEnvironmentNames = () => {

    if(favQuestions.length > 0) {

      const uniqueNames = new Set();
      favQuestions.forEach(question => {
        if (question.Intent === selectedTab && question.DocsEnv && question.DocsEnv.Name) {
          uniqueNames.add(question.DocsEnv.Name);
        }
      });

      const uniqueNamesArr = Array.from(uniqueNames);
      setUniqueEnvironmentNames(uniqueNamesArr);
    }
  }

  const handleDragStart = (e, question) => {
    setDraggingItem(question);
  };

  const handleDragEnd = () => {
    setDraggingItem(null);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e, targetQuestion) => {
    const currentIndex = favQuestions.indexOf(draggingItem);
    const targetIndex = favQuestions.indexOf(targetQuestion);

    if (currentIndex !== -1 && targetIndex !== -1) {

      const updatedQuestions = [...favQuestions];
      updatedQuestions.splice(currentIndex, 1);
      updatedQuestions.splice(targetIndex, 0, draggingItem);
      setFavQuestions(updatedQuestions);
      //ma sa ulozit v db poradie?
    }
    setDraggingItem(null);
  };

  const handleDropInGroup = (e, targetQuestion) => {
    const currentIndex = favQuestions.indexOf(draggingItem);
    const targetIndex = favQuestions.indexOf(targetQuestion);

    if (currentIndex !== -1 && targetIndex !== -1 && draggingItem.DocsEnvId === targetQuestion.DocsEnvId) {
      const updatedQuestions = [...favQuestions];
      updatedQuestions.splice(currentIndex, 1);
      updatedQuestions.splice(targetIndex, 0, draggingItem);
      setFavQuestions(updatedQuestions);
      // TODO ako udzrat poradie pri refreshi / logine / etc
    }
    setDraggingItem(null);
  }

  useEffect(() => {
    fetchQuestions();
    populateEnvironmentNames();
  }, [selectedTab]);

  useEffect(() => {
    populateEnvironmentNames();
  }, [favQuestions]);

  const togglePanel = () => {
    if(screen.width <= 768){
      setIsQuestionsVisible((prevState) => !prevState);
    }
  }
  
  const handleQuestionClick = (id) => {
    if(!formButtonEnabled){
      return
    }   
    
    setFormInputEnabled(false);
    setFormButtonEnabled(false);

    const favQuestion = favQuestions.filter((item) => item.Id === id);

    const clickedEnvironmentId = favQuestion[0].DocsEnv?.Id;
    if (favQuestion[0].DocsEnv?.Id && chatEnvironmentId !== clickedEnvironmentId) {
      setChatEnvironmentId(clickedEnvironmentId);
      setCookie("ENV", clickedEnvironmentId);
    }

    const myMessage = favQuestions.filter((item) => item.Id === id).map((item) => item.Question);

    setSelectedQuestion(myMessage[0]);
    return;
  };

  const handleDeleteQuestion = (id) => {
    deleteFavouriteQuestion(id)
      .then((success) => {
        if (success) {
          fetchQuestions();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <div id="questionPanel" className={`question-panel ${isQuestionsVisible ? 'open' : 'close'}`}>
      <div id="group-1" className={`panel-group-wrapper open`}>
        <div className="question-panel-title">
          <h2>{t('savedQ')}</h2>
        </div>
        
        <ol className="question-list">
        {uniqueEnvironmentNames.length > 0 ? (
           uniqueEnvironmentNames.map((folderName, index) => (
            <React.Fragment key={index}>
              <h3>{folderName}</h3>
              {favQuestions.length > 0 && favQuestions.map((question, index) => (
                question.Intent === selectedTab && question.DocsEnv.Name === folderName ? (
                  <div key={question.Id} className="question-item table separator"
                      draggable="true"
                      onDragStart={(e) => handleDragStart(e, question)}
                      onDragEnd={handleDragEnd}
                      onDragOver={handleDragOver}
                      onDrop={(e) => handleDropInGroup(e, question)}
                    >
                      <span className="question-hover"
                            onClick={() => {togglePanel(); handleQuestionClick(question.Id)}}>
                            {question.Question}
                      </span>
                    <div className="delete-question material-symbols-outlined" onClick={() => handleDeleteQuestion(question.Id)}>
                      do_not_disturb_on
                    </div>
                  </div>
                ) : null
              ))}
            </React.Fragment>
          ))
        ):(
          favQuestions.length > 0 && favQuestions.map((question, index) => (
            question.Intent === selectedTab ? (
              <div key={question.Id} className="question-item table separator"
                draggable="true"
                onDragStart={(e) => handleDragStart(e, question)}
                onDragEnd={handleDragEnd}
                onDragOver={handleDragOver}
                onDrop={(e) => handleDrop(e, question)}
              >
                <span className="question-hover" 
                      onClick={() => {togglePanel(); handleQuestionClick(question.Id)}}>
                  {question.Question}
                </span>
                <div className="delete-question material-symbols-outlined" onClick={() => handleDeleteQuestion(question.Id)}>
                  do_not_disturb_on
                </div>
              </div>
            ) : null
          ))
        )}

        <VersionDisplay/>

        </ol>
      </div>
    </div>
  );
}
                
export default ChatQuestions;
